var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-tabs",
    {
      attrs: {
        "background-color": _vm.backgroundColor,
        "center-active": _vm.centerActive,
        dark: _vm.dark,
        "show-arrows": "",
        "slider-color": _vm.sliderColor
      }
    },
    _vm._l(_vm.items, function(item, index) {
      return !item.hidden
        ? _c(
            "v-tab",
            {
              key: index,
              attrs: { dark: "", link: "", exact: "", to: item.path }
            },
            [
              _vm._t(
                "tab.item",
                function() {
                  return [_c("span", [_vm._v(_vm._s(item.label))])]
                },
                { item: item }
              )
            ],
            2
          )
        : _vm._e()
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }